<template>
<div class="background">
  <div class="container">
    <contact-form id="form"></contact-form>
    <contact-creds id="creds"></contact-creds>
  </div>
</div>
</template>
<script>
import ContactForm from '@/components/ContactForm.vue';
import ContactCreds from '@/components/ContactCreds.vue';
export default {
  name: 'Contact',
  components: { ContactForm, ContactCreds }
}
</script>
<style lang="scss" scoped>
  .background {
    background: rgb(80, 80, 80);
    // background: rgb(192, 191, 191);
    // background: rgb(51, 51, 51);
  }
  .container {
    width: 90%;
    margin-left: 5%;
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    #form {
      width: 70%;
    }
    #creds {
      width: 30%;
    }
  }

  @media screen and (max-width: 1024px) {
    .container {
      display: block;
      #form {
        width: 100%;
      }
      #creds {
        margin-top: 3%;
        width: 97%;
      }
    }
  }
</style>
